import type { PercentageKey } from "../percentage";
import type { AmountsAndVatRate, Price } from "./price";

const negateVatAmounts = (
    vatAmounts: Price["vatAmounts"],
): Price["vatAmounts"] => {
    if (!vatAmounts) return vatAmounts;
    const negatedVatAmounts: Price["vatAmounts"] = {};
    for (const vatAmount of Object.entries(vatAmounts)) {
        const [key, value] = vatAmount as unknown as [
            PercentageKey,
            AmountsAndVatRate,
        ];
        negatedVatAmounts[key] = {
            amountExcludingVat: -value.amountExcludingVat,
            amountIncludingVat: -value.amountIncludingVat,
            vatAmount: -value.vatAmount,
            vatRate: value.vatRate,
        };
    }
    return negatedVatAmounts;
};

const negatePrice = <
    T extends Pick<
        Price,
        "amountExcludingVat" | "amountIncludingVat" | "vatAmount" | "vatAmounts"
    >,
>(
    price: T,
): T => {
    return {
        ...price,
        amountIncludingVat: -price.amountIncludingVat,
        amountExcludingVat: -price.amountExcludingVat,
        vatAmount: -price.vatAmount,
        vatAmounts: price.vatAmounts
            ? negateVatAmounts(price.vatAmounts)
            : undefined,
    };
};

const absVatAmounts = (
    vatAmounts: Price["vatAmounts"],
): Price["vatAmounts"] => {
    if (!vatAmounts) return vatAmounts;
    const negatedVatAmounts: Price["vatAmounts"] = {};
    for (const vatAmount of Object.entries(vatAmounts)) {
        const [key, value] = vatAmount as unknown as [
            PercentageKey,
            AmountsAndVatRate,
        ];
        negatedVatAmounts[key] = {
            amountExcludingVat: Math.abs(value.amountExcludingVat),
            amountIncludingVat: Math.abs(value.amountIncludingVat),
            vatAmount: Math.abs(value.vatAmount),
            vatRate: value.vatRate,
        };
    }
    return negatedVatAmounts;
};

const absPrice = (price: Price): Price => {
    if (price.amountIncludingVat > 0) return price;
    return negatePrice(price);
    // return {
    //     ...price,
    //     amountIncludingVat: Math.abs(price.amountIncludingVat),
    //     amountExcludingVat: Math.abs(price.amountExcludingVat),
    //     vatAmount: Math.abs(price.vatAmount),
    //     vatAmounts: price.vatAmounts
    //         ? negateVatAmounts(price.vatAmounts)
    //         : undefined,
    // };
};

export { absPrice, absVatAmounts, negatePrice, negateVatAmounts };
